import { VscQuestion } from 'react-icons/vsc'

export const explain = (text: string, mobileHide = false, topMargin = '-0.6', size = '2') => 
<VscQuestion 
    style={{fontSize: `${size}rem`, marginLeft: '0.5rem', marginTop: `${topMargin}rem`, color: '#98A2B3'}} 
    data-tip={text}
    className={mobileHide ? 'hide-tooltip' : ''}
    data-class="my-tooltip"
/> 